import usFlag from "../assets/images/flags/us.jpg";
import vnFlag from "../assets/images/flags/vn.png";

const languages = {
  vn: {
    label: "Vietnamese",
    flag: vnFlag,
  },
  en: {
    label: "English",
    flag: usFlag,
  },
};

export default languages;
